var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPressureSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#455063;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gauge"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    className: "cls-1",
    d: "M300,89.45C183.7,89.46,89.44,183.73,89.45,300S183.73,510.56,300,510.55,510.55,416.28,510.55,300,416.22,89.58,300,89.45ZM300,493A193.26,193.26,0,0,1,114.42,352.68H239.21a73.69,73.69,0,0,0,60.77,35,73.7,73.7,0,0,0,60.8-35H485.65A193.28,193.28,0,0,1,300,493ZM355.91,335.1a8.79,8.79,0,0,0-7.56,4.33A57.41,57.41,0,0,1,300,370.19a57.38,57.38,0,0,1-48.39-30.84,8.79,8.79,0,0,0-7.57-4.33H110.24c-19.48-104.8,49.69-205.55,154.5-225s205.55,49.69,225,154.49a193.1,193.1,0,0,1,0,70.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    className: "cls-1",
    d: "M364,214.85l-52.23,52.23A34.68,34.68,0,0,0,300,264.91a35.51,35.51,0,1,0,26.44,12.28l50-50A8.78,8.78,0,0,0,364,214.8ZM300,317.56A17.55,17.55,0,1,1,317.54,300h0A17.54,17.54,0,0,1,300,317.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    className: "cls-1",
    d: "M300,168.42a8.78,8.78,0,0,0,8.78-8.78V124.55a8.78,8.78,0,0,0-17.54-.77c0,.26,0,.51,0,.77v35.09A8.78,8.78,0,0,0,300,168.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    className: "cls-1",
    d: "M475.45,291.24H440.36a8.78,8.78,0,1,0-.76,17.54c.25,0,.51,0,.76,0h35.09a8.78,8.78,0,0,0,0-17.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    className: "cls-1",
    d: "M159.62,291.24H124.53a8.78,8.78,0,1,0-.76,17.54c.25,0,.51,0,.76,0h35.09a8.78,8.78,0,0,0,0-17.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-1",
    d: "M236.59,172.63l-15-25.89a8.78,8.78,0,0,0-15.2,8.78l15,25.89A8.78,8.78,0,0,0,236.83,173l-.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-1",
    d: "M456.56,209.65a8.79,8.79,0,0,0-12-3.33h-.1l-25.89,15a8.78,8.78,0,0,0,8.78,15.2l25.89-15A8.78,8.78,0,0,0,456.56,209.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-1",
    d: "M181.5,221.45h-.1l-25.89-15a8.78,8.78,0,0,0-8.88,15.15h.1l25.89,15a8.78,8.78,0,1,0,9.21-14.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-1",
    d: "M390.22,143.58a8.78,8.78,0,0,0-11.92,3.18l-15,25.89A8.78,8.78,0,1,0,378.18,182a6.05,6.05,0,0,0,.32-.55l15-25.89A8.78,8.78,0,0,0,390.22,143.58Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressureSymbol);
export default __webpack_public_path__ + "static/media/pressure-symbol.bd507ec726f6bbd86771be6bd749768f.svg";
export { ForwardRef as ReactComponent };